import { render, staticRenderFns } from "./AProviderSelector.vue?vue&type=template&id=23864b33&scoped=true"
import script from "./AProviderSelector.vue?vue&type=script&lang=js"
export * from "./AProviderSelector.vue?vue&type=script&lang=js"
import style0 from "./AProviderSelector.vue?vue&type=style&index=0&id=23864b33&prod&lang=scss"
import style1 from "./AProviderSelector.vue?vue&type=style&index=1&id=23864b33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23864b33",
  null
  
)

export default component.exports